import Mapbox from '@/framework/map/mapbox'
import Bar3D from '@/framework/map/three/threebox'
import mapTips from '@/framework/components/MapTips.vue'
export{
    Mapbox,
    Bar3D
}
export default {
    install(Vue) {
        Vue.component('map-Tips', mapTips)
    }
}
// const components = [
//     mapTips
//     // ...如果还有的话继续添加
//   ]
// const install = function (Vue, opts = {}) {
//     components.map(component => {
//         Vue.component(component.name, component);
//     })
// }
// /* 支持使用标签的方式引入 */
// if (typeof window !== 'undefined' && window.Vue) {
//     install(window.Vue);
// }
// export default {
//     mapTips,
//     Mapbox,
//     Bar3D
//     // ...如果还有的话继续添加
//   }


// WEBPACK FOOTER //
// ./src/index.js